export function RedLineFunc(x: number) {
    return (
        1.2 *
        (Math.sin(x * 0.5 * (Math.sin(0.1) * 0.5 + 0.5)) +
            Math.sin(x * 0.25) * (0.5 + (Math.sin(0.5 + x * 0.35) * 0.5 + 0.5)))
    );
}

export function InitSDFDestrHallwayScene() {
    return /* glsl */ `


	#define HALLWAY_LIGHT
	#define SDF_DISABLE_MESH

	

	float RedLineFunc(float x)
	{
		
		float freqMod = 1.0;
		freqMod += max(0.0, -5.0 + x * 0.01);
		
		float sinMid = sin(x * 0.5 * freqMod * (sin(0.1) * 0.5 + 0.5));
		float sinLow = sin(x * 0.25 * freqMod) * (0.5 + (sin(0.5 + x * 0.35) * 0.5 + 0.5));

		float res = 1.5 * sinMid + sinLow;
		res = sinLow * 1.7;

		return res;
        
	}

	float PyramidHM(vec2 uv, float t)
	{
	    float r = 2.0*t*pow(1.0 - length(uv)/sqrt(2.0), 1.5);
	
	    uv = mat2(cos(r),sin(r),-sin(r),cos(r))*uv;
	
	    uv = abs(uv)/sqrt(2.0);
	    return 1.0 - max(uv.x, uv.y);
	}


	#define SDF_MAX_DISTANCE 150.0

	#define HALLWAY_POS_Y 3.0
	#define HALLWAY_EXT_X 4.0
	#define HALLWAY_EXT_Y 7.0
	#define HALLWAY_EXT_Z 100.0


	const vec3 OceanRoomExtent = vec3(35.0, 30.0, 50.0);
	const vec3 OceanRoomCenter = vec3(0.0, 0.0, HALLWAY_EXT_Z + OceanRoomExtent.z);

	const float pyrHeight = 1.0;
	const float pyrRad = 0.0025;
	//const float pyrScale = 1.0 / pyrExtent;
	//const float pyrExtent = 10.0;
	//const vec3 pyrPos = vec3(0.0, 20.0, OceanRoomCenter.z);

	float sdPyramid( in vec3 curPos, vec3 pyrPos, float pyrScale, in float h )
	{
		vec3 p =  curPos - pyrPos;

		h *= 0.65 * (1.0 + min(0.5, SceneBuffer.PyramidParams.x * 0.001));
		//h *= 1.25;

		p.y *= -1.0;
	   	//p.y += 1.0;

	   	p *= pyrScale;

		   #if 1
			{
				float angle = p.y * p.y * sin(SceneBuffer.PyramidParams.x * 0.2) * 1.0;
				// Rotate the stretched position
				float cosAngle = cos(angle);
				float sinAngle = sin(angle);
				vec2 rotatedPosition = vec2(
				   p.x * cosAngle - p.y * sinAngle,
				   p.x * sinAngle + p.y * cosAngle
				);
				p.xy = rotatedPosition;
			}
		   #endif
		
		#if 1//SPIRAL
		{
	   		float angle = p.y * SceneBuffer.PyramidParams.y * 0.4;
	   		//float angle = p.y * 0.5;
	   		//float angle = SceneBuffer.SDFHelperFloat1;
			// Rotate the stretched position
			float cosAngle = cos(angle);
			float sinAngle = sin(angle);
			vec2 rotatedPosition = vec2(
				p.x * cosAngle - p.z * sinAngle,
				p.x * sinAngle + p.z * cosAngle
			);
			p.xz = rotatedPosition;
		}
		#endif

	   	float m2 = h*h + 0.25;
					
	   	// symmetry
	   	p.xz = abs(p.xz); // do p=abs(p) instead for double pyramid
	   	p.xz = (p.z>p.x) ? p.zx : p.xz;
	   	p.xz -= 0.5;
					
	   	// project into face plane (2D)
	   	vec3 q = vec3( p.z, h*p.y-0.5*p.x, h*p.x+0.5*p.y);
					
	   	float s = max(-q.x,0.0);
	   	float t = clamp( (q.y-0.5*q.x)/(m2+0.25), 0.0, 1.0 );
					
	   	float a = m2*(q.x+s)*(q.x+s) + q.y*q.y;
			float b = m2*(q.x+0.5*t)*(q.x+0.5*t) + (q.y-m2*t)*(q.y-m2*t);
					
	   	float d2 = max(-q.y,q.x*m2+q.y*0.5) < 0.0 ? 0.0 : min(a,b);
					
	   	// recover 3D and scale, and add sign
	   	return sqrt( (d2+q.z*q.z)/m2 ) * sign(max(q.z,-p.y));;
	}

	vec3 calcNormalPyr( in vec3 pos)
	{
		vec3 pyrPos = vec3(0.0, 41.0, 200.0);
		float pyrScale = 1.0 / 65.0;
		// inspired by tdhooper and klems - a way to prevent the compiler from inlining map() 4 times
	    vec3 n = vec3(0.0);
	    for( int i=0; i<4; i++ )
	    {
	        vec3 e = 0.5773*(2.0*vec3((((i+3)>>1)&1),((i>>1)&1),(i&1))-1.0);
	        n += e*sdPyramid(pos+0.0005*e, pyrPos, pyrScale, pyrHeight);
	      //if( n.x+n.y+n.z>100.0 ) break;
	    }
	    return normalize(n);
	}

	float CalcPyrThickness( in vec3 pos, in vec3 nor )
	{
		float pyrScale = 1.0 / 65.0;

		float occ = 0.0;
	    float sca = 1.0;

	    for( int i=0; i<3; i++ )
	    {
			//const float stepSize = 0.25;
			float ran = hash( uint(gl_FragCoord.x) * uint(i) + 1920U* uint(gl_FragCoord.y) + (1920U*1080U) );  
			//ran = 1.0;
			float stepSize = 0.1 + ran * 0.01;
	        float h = stepSize + stepSize * float(i);
		
			vec3 pyrPos = vec3(0.0, 41.0, 200.0);
			float d = -sdPyramid(pos - h*nor, pyrPos, pyrScale, pyrHeight);

			float diff = h-d;
	        occ += pow(diff, 1.0)*0.1*sca;
	        //sca *= 0.1;
	        if( occ>0.35 ) break;
	    }
	    return clamp( 1.0 - 3.0*occ, 0.0, 1.0 );
	}

	// Dave_Hoskins hash functions (https://www.shadertoy.com/view/4djSRW)
	float Hash11(float p)
	{
		vec3 p3  = fract(vec3(p) * 443.897);
	    p3 += dot(p3, p3.yzx + 19.19);
	    return fract((p3.x + p3.y) * p3.z);
	}

	//Rand Direction for 3D Position
	vec3 Hash33(vec3 p3)
	{
		p3 = fract(p3 * vec3(443.897, 441.423, 437.195));
	    p3 += dot(p3, p3.yxz+19.19);
	    return fract((p3.xxy + p3.yxx)*p3.zyx);
	}

	// Great tip from iq, see: https://www.shadertoy.com/view/4dBXz3
	vec3 MirrorVector(in vec3 v, in vec3 n)
	{
	    return v + 2.0 * n * max(0.0, -dot(n,v));
	}

	vec3 GenerateSampleVector(in vec3 norm, in float i)
	{
		vec3 randDir = normalize(Hash33(norm + i));
	    return MirrorVector(randDir, norm);
	}

	const float SSSSampleDepth       = 0.5;
	const float SSSThicknessSamples  = 32.0;
	const float SSSThicknessSamplesI = 0.03125;

	float CalcPyrThicknessHemisphere(in vec3 pos, in vec3 norm)
	{
	    // Perform a number of samples, accumulate thickness, and then divide by number of samples.
	    float thickness = 0.0;
	
	    for(float i = 0.0; i < SSSThicknessSamples; ++i)
	    {
	        // For each sample, generate a random length and direction.
	        float sampleLength = Hash11(i) * SSSSampleDepth;
	        vec3 sampleDir = GenerateSampleVector(-norm, i);
		
	        // Thickness is the SDF depth value at that sample point.
	        // Remember, internal SDF values are negative. So we add the 
	        // sample length to ensure we get a positive value.
	        //thickness += sampleLength + Scene(pos + (sampleDir * sampleLength)).x;
			vec3 pyrPos = vec3(0.0, 41.0, 200.0);
			float pyrScale = 1.0 / 65.0;
	        thickness += sampleLength + sdPyramid(pos + (sampleDir * sampleLength), pyrPos, pyrScale, pyrHeight);
	    }
	
	    // Thickness on range [0, 1], where 0 is maximum thickness/density.
	    // Remember, the resulting thickness value is multipled against our 
	    // lighting during the actual SSS calculation so a value closer to 
	    // 1.0 means less absorption/brighter SSS lighting.
	    return clamp(thickness * SSSThicknessSamplesI, 0.0, 1.0);
	}

	float sdPipe( in vec3 p, in vec3 h ) {
		return length(h.xy-p.xy) - h.z;
	}

	float sceneSDF(vec3 curPos, bool bRayMeshIntersection, bool bRayMeshIntersection2)
	{
		float curD = SDF_MAX_DISTANCE;

		const vec3 sceneExtent = vec3(HALLWAY_EXT_X, HALLWAY_EXT_Y, 30.0);

		const float posY = HALLWAY_POS_Y;

		#if 1
		if(curPos.z < HALLWAY_EXT_Z)
		{
			//left
			{
				vec3 pointOnPlane = vec3(-sceneExtent.x, 0.0, 0.0);
				vec3 planeN = vec3(1.0, 0.0, 0.0);
				float d = -dot(pointOnPlane, planeN);
				float dToPlane = sdPlane(curPos, planeN, d);
			#if 1
				dToPlane -= sdTiledPyramid(curPos.yz, SceneBuffer.Time) * 0.5;
    		#endif
				curD = min(curD, dToPlane);
				//curD = min(curD, abs(-sceneExtent.x - curPos.x));
			}
			//right
			{
				/* vec3 pointOnPlane = vec3(sceneExtent.x, 0.0, 0.0);
				vec3 planeN = vec3(-1.0, 0.0, 0.0);
				float d = -dot(pointOnPlane, planeN);
				curD = min(curD, sdPlane(curPos, planeN, d)); */
				float dToPlane = /* abs */(sceneExtent.x - curPos.x);
			#if 1
				dToPlane -= sdTiledPyramid(curPos.yz, SceneBuffer.Time) * 0.5;
    		#endif
				curD = min(curD, dToPlane);
				
			}
			//floor
			{
				vec3 pointOnPlane = vec3(0, posY -sceneExtent.y, 0.0);
				vec3 planeN = vec3(0.0, 1.0, 0.0);
				float d = -dot(pointOnPlane, planeN);
				curD = min(curD, sdPlane(curPos, planeN, d));
				//curD = min(curD, /* abs */(-2.5 - curPos.y));
			}
			//ceil
			{
				vec3 pointOnPlane = vec3(0.0, posY + sceneExtent.y, 0.0);
				vec3 planeN = vec3(0.0, -1.0, 0.0);
				float d = -dot(pointOnPlane, planeN);
				curD = min(curD, sdPlane(curPos, planeN, d));
				//curD = min(curD, /* abs */(sceneExtent.y - curPos.y));
			}

			//column
			{
				const vec3 columnCenter = vec3(0.0, posY, 0.0);
				const vec3 columnExtent = vec3(1.0, sceneExtent.y, 1.0);
				const float columnRad = 0.045;
				const float distanceBetweenColumns = 20.0;
				const int numColumns = 5;
				for(int i = 0; i < numColumns; i++)
				{
					vec3 curColumnPosLeft = vec3(-sceneExtent.x + columnExtent.x * 0.15, columnCenter.y, 1.0 + float(i) * distanceBetweenColumns);
					curD = min(curD, sdRoundBox(curPos, curColumnPosLeft, columnExtent, columnRad));
					vec3 curColumnPosRight = vec3(sceneExtent.x - columnExtent.x * 0.15, columnCenter.y, 1.0 + float(i) * distanceBetweenColumns);
					curD = min(curD, sdRoundBox(curPos, curColumnPosRight, columnExtent, columnRad));
					
				}
			}


			//curD = min(curD, sdBase(curPos));

			#if 0
				float offx = 13.1*floor(curPos.x)+17.7*floor(curPos.z);
    			float fb =  fbm3(1.1 * vec3(curPos.x+offx,curPos.y,curPos.z));
				fb *= simplex3d(curPos * 0.5);
				//float fb = simplex3d(curPos);
    			if( fb>0.0 )
    			    curD = curD + fb * 1.0;
    		#endif

			#if 0
				float fb = sin(curPos.z * 3.0);
				if( fb>0.0 )
					curD = curD + fb * 0.5;
			#endif
			
			
		}
		#endif


		#if 0 //Ocean Room

		//curD = min(curD, -sdBox(curPos, OceanRoomCenter, OceanRoomExtent));

		if(sdBox(curPos, OceanRoomCenter, OceanRoomExtent) < curD)
		{
			float tileScale = 0.4;
			{
				float bump = tileHeightMap(curPos.yz * vec2(0.2, 0.1) * 3.0 * tileScale, 0.1) * 0.2;
				//left
				{
					float dToPlane = curPos.x + OceanRoomExtent.x - bump;
					curD = min(curD, dToPlane);
				}
				//right
				{
					float dToPlane = -curPos.x + OceanRoomExtent.x - bump;
					curD = min(curD, dToPlane);
				}
			}
			//front
			{
				float bump = tileHeightMap(curPos.xy * vec2(0.1, 0.2) * 3.0 * tileScale, 0.1);
				float dToPlane = OceanRoomCenter.z + OceanRoomExtent.z - curPos.z - bump * 0.2;
				curD = min(curD, dToPlane);
			}
			//ceil
			{
				float dToPlane = OceanRoomCenter.y + OceanRoomExtent.y - curPos.y;
				curD = min(curD, dToPlane);
			}

		}

		
		#endif

		return curD;
	}

	// float SDFComputeShadow(vec3 p, vec3 lightPos)
	// {
	// 	return 1.0;
	// }

	float SDFComputeShadow(vec3 p, vec3 lightPos)
	{
		float res = 1.0;

		//Compute self-shadow bias
		float bias = 0.0;
		
		float d = length(lightPos - p);
		vec3 l = (lightPos - p) / d;

		float maxT = d;

		float w = 0.1;
		float minT = 0.01;
		float t = minT;

	#if 1 //compute self intersection bias
		float sdf = SDF_MAX_DISTANCE;
		sdf = min(sdf, sceneSDF(p, false, false));

		float selfIntersectThres = 0.01;

		if(sdf < selfIntersectThres)
		{
			bias = abs(sdf) + 0.01;
		}
	#endif

		float ph = 1e20;
		for( int i=0; i<16; i++ )
		{
			//float h = sceneSDF(p + l*t, bRayMeshIntersection);
			vec3 curPos = p + l*t;
			float h = 20.0;

			h = min(h, sceneSDF(curPos, false, false));

			h += bias;

			res = min( res, h/(w*t) );
		
			t += h;
		
			if( res<0.01 || t>maxT ) break;
		}

		res = clamp( res, 0.0, 1.0 );
		return res*res*(3.0-2.0*res);

		//return res;

	}


	#define DRAG_MULT 0.28 // changes how much waves pull on the water
	#define WATER_DEPTH 1.5 // how deep is the water
	#define ITERATIONS_RAYMARCH 22 // waves iterations of raymarching
	#define ITERATIONS_NORMAL 37 // waves iterations when calculating normals

			// Calculates wave value and its derivative, 
	// for the wave direction, position in space, wave frequency and time
	vec2 wavedx(vec2 position, vec2 direction, float frequency, float timeshift) 
	{
		float x = dot(direction, position) * frequency + timeshift;
		float wave = exp(sin(x) - 1.0);
		float dx = wave * cos(x);
		return vec2(wave, -dx);
	  }
  
  	// Calculates waves by summing octaves of various waves with various parameters
  	float getwaves(vec2 position, int iterations) 
	{
		float wavePhaseShift = length(position) * 0.1; // this is to avoid every octave having exactly the same phase everywhere
		//wavePhaseShift = 0.0;
		float iter = 0.0; // this will help generating well distributed wave directions
		float frequency = 1.0; // frequency of the wave, this will change every iteration
		float timeMultiplier = 2.0; // time multiplier for the wave, this will change every iteration
		float weight = 1.0;// weight in final sum for the wave, this will change every iteration
		float sumOfValues = 0.0; // will store final sum of values
		float sumOfWeights = 0.0; // will store final sum of weights
		for(int i=0; i < iterations; i++) {
		  // generate some wave direction that looks kind of random
		  vec2 p = vec2(sin(iter), cos(iter));
		
		  // calculate wave data
		  vec2 res = wavedx(position, p, frequency, SceneBuffer.Time * timeMultiplier + wavePhaseShift);
		
		  // shift position around according to wave drag and derivative of the wave
		  position += p * res.y * weight * DRAG_MULT;
		
		  // add the results to sums
		  sumOfValues += res.x * weight;
		  sumOfWeights += weight;
		
		  // modify next octave ;
		  weight = mix(weight, 0.0, 0.2);
		  frequency *= 1.18;
		  timeMultiplier *= 1.07;
		
		  // add some kind of random value to make next wave look random too
		  iter += 1232.399963;
		}
		// calculate and return
		return sumOfValues / sumOfWeights;
  	}
  
  	// Raymarches the ray from top water layer boundary to low water layer boundary
  	float raymarchwater(vec3 camera, vec3 start, vec3 end, float depth) 
	{
		vec3 pos = start;
		vec3 dir = normalize(end - start);
		for(int i=0; i < 64; i++) {
		  // the height is from 0 to -depth
		  float height = getwaves(pos.xz, ITERATIONS_RAYMARCH) * depth - depth;
		  // if the waves height almost nearly matches the ray height, assume its a hit and return the hit distance
		  if(height + 0.01 > pos.y) {
			return distance(pos, camera);
		  }
		  // iterate forwards according to the height mismatch
		  pos += dir * (pos.y - height);
		}
		// if hit was not registered, just assume hit the top layer, 
		// this makes the raymarching faster and looks better at higher distances
		return distance(start, camera);
  	}
  
  	// Calculate normal at point by calculating the height at the pos and 2 additional points very close to pos
  	vec3 waternormal(vec2 pos, float e, float depth) 
	{
		vec2 ex = vec2(e, 0);
		float H = getwaves(pos.xy, ITERATIONS_NORMAL) * depth;
		vec3 a = vec3(pos.x, H, pos.y);
		return normalize(
		  cross(
			a - vec3(pos.x - e, getwaves(pos.xy - ex.xy, ITERATIONS_NORMAL) * depth, pos.y), 
			a - vec3(pos.x, getwaves(pos.xy + ex.yx, ITERATIONS_NORMAL) * depth, pos.y + e)
		  )
		);
  	}



	//SEA 2
	// sea
	const int ITER_GEOMETRY = 3;
	const int ITER_FRAGMENT = 5;
	const float SEA_HEIGHT = 0.8;
	const float SEA_CHOPPY = 4.0;
	const float SEA_SPEED = 1.5;
	const float SEA_FREQ = 0.16;
	#define SEA_TIME (1.0 + SceneBuffer.Time * SEA_SPEED)
	const mat2 octave_m = mat2(1.6,1.2,-1.2,1.6);

	float seahash( vec2 p ) {
		float h = dot(p,vec2(127.1,311.7));	
		return fract(sin(h)*43758.5453123);
	}
	float seanoise( in vec2 p ) {
		vec2 i = floor( p );
		vec2 f = fract( p );	
		vec2 u = f*f*(3.0-2.0*f);
		return -1.0+2.0*mix( mix( seahash( i + vec2(0.0,0.0) ), 
		seahash( i + vec2(1.0,0.0) ), u.x),
					mix( seahash( i + vec2(0.0,1.0) ), 
					seahash( i + vec2(1.0,1.0) ), u.x), u.y);
	}
	
	// sea
	float sea_octave(vec2 uv, float choppy) {
	    uv += seanoise(uv);        
	    vec2 wv = 1.0-abs(sin(uv));
	    vec2 swv = abs(cos(uv));    
	    wv = mix(wv,swv,wv);
	    return pow(1.0-pow(wv.x * wv.y,0.65),choppy);
	}

	#define SEA_POS_Y -5.0

	float sea_map(vec3 p) {
	    float freq = SEA_FREQ;
	    float amp = SEA_HEIGHT;
	    float choppy = SEA_CHOPPY;
	    vec2 uv = p.xz; uv.x *= 0.75;

		float curTime = SEA_TIME;
	
	    float d, h = 0.0;    
	    for(int i = 0; i < ITER_GEOMETRY; i++) {        
	    	d = sea_octave((uv+curTime)*freq,choppy);
	    	d += sea_octave((uv-curTime)*freq,choppy);
	        h += d * amp;        
	    	uv *= octave_m; freq *= 1.9; amp *= 0.22;
	        choppy = mix(choppy,1.0,0.2);
	    }
	    return p.y - (h + SEA_POS_Y);
	}

	float sea_map_detailed(vec3 p) {
	    float freq = SEA_FREQ;
	    float amp = SEA_HEIGHT;
	    float choppy = SEA_CHOPPY;
	    vec2 uv = p.xz; uv.x *= 0.75;

		float curTime = SEA_TIME;
	
	    float d, h = 0.0;    
	    for(int i = 0; i < ITER_FRAGMENT; i++) {        
	    	d = sea_octave((uv+curTime)*freq,choppy);
	    	d += sea_octave((uv-curTime)*freq,choppy);
	        h += d * amp;        
	    	uv *= octave_m; freq *= 1.9; amp *= 0.22;
	        choppy = mix(choppy,1.0,0.2);
	    }
	    return p.y - (h + SEA_POS_Y);
	}

	vec3 getNormal(vec3 p, float eps) {
		vec3 n;
		n.y = sea_map_detailed(p);    
		n.x = sea_map_detailed(vec3(p.x+eps,p.y,p.z)) - n.y;
		n.z = sea_map_detailed(vec3(p.x,p.y,p.z+eps)) - n.y;
		n.y = eps;
		return normalize(n);
	}
	
	float heightMapTracing(vec3 ori, vec3 dir, float startT,  out vec3 p) {  
		const float tm = 0.0;
		const float tx = 1000.0;
		/* if(dir.y > 0.1)
		{
			p = ori + dir * tx;
			return tx; 
		} */

		float t = max(0.0001, startT);
		p = ori + dir * t;

		for(int i = 0; i < 48; i++) {
			float hDiff = sea_map(p); 

			float hitDist = 0.001 * t;
			hitDist += 0.001 * float(i);
			
			if((hDiff) < hitDist)
			{
				return t;
			}

			//t += hDiff * min(1.0, (0.95 + 0.01 * float(i)));
			t += hDiff;
			
			p = ori + dir * t;

			//p += dir * hDiff * min(1.0, (0.95 + 0.01 * float(i)));
		}
		return 0.0;
	}












	vec4 mod289(vec4 x)
	{
	    return x - floor(x / 289.0) * 289.0;
	}

	vec4 permute(vec4 x)
	{
	    return mod289((x * 34.0 + 1.0) * x);
	}

	vec4 snoise(vec3 v)
	{
	    const vec2 C = vec2(1.0 / 6.0, 1.0 / 3.0);

	    // First corner
	    vec3 i  = floor(v + dot(v, vec3(C.y)));
	    vec3 x0 = v   - i + dot(i, vec3(C.x));

	    // Other corners
	    vec3 g = step(x0.yzx, x0.xyz);
	    vec3 l = 1.0 - g;
	    vec3 i1 = min(g.xyz, l.zxy);
	    vec3 i2 = max(g.xyz, l.zxy);

	    vec3 x1 = x0 - i1 + C.x;
	    vec3 x2 = x0 - i2 + C.y;
	    vec3 x3 = x0 - 0.5;

	    // Permutations
	    vec4 p =
	      permute(permute(permute(i.z + vec4(0.0, i1.z, i2.z, 1.0))
	                            + i.y + vec4(0.0, i1.y, i2.y, 1.0))
	                            + i.x + vec4(0.0, i1.x, i2.x, 1.0));

	    // Gradients: 7x7 points over a square, mapped onto an octahedron.
	    // The ring size 17*17 = 289 is close to a multiple of 49 (49*6 = 294)
	    vec4 j = p - 49.0 * floor(p / 49.0);  // mod(p,7*7)

	    vec4 x_ = floor(j / 7.0);
	    vec4 y_ = floor(j - 7.0 * x_); 

	    vec4 x = (x_ * 2.0 + 0.5) / 7.0 - 1.0;
	    vec4 y = (y_ * 2.0 + 0.5) / 7.0 - 1.0;

	    vec4 h = 1.0 - abs(x) - abs(y);

	    vec4 b0 = vec4(x.xy, y.xy);
	    vec4 b1 = vec4(x.zw, y.zw);

	    vec4 s0 = floor(b0) * 2.0 + 1.0;
	    vec4 s1 = floor(b1) * 2.0 + 1.0;
	    vec4 sh = -step(h, vec4(0.0));

	    vec4 a0 = b0.xzyw + s0.xzyw * sh.xxyy;
	    vec4 a1 = b1.xzyw + s1.xzyw * sh.zzww;

	    vec3 g0 = vec3(a0.xy, h.x);
	    vec3 g1 = vec3(a0.zw, h.y);
	    vec3 g2 = vec3(a1.xy, h.z);
	    vec3 g3 = vec3(a1.zw, h.w);

	    // Compute noise and gradient at P
	    vec4 m = max(0.6 - vec4(dot(x0, x0), dot(x1, x1), dot(x2, x2), dot(x3, x3)), 0.0);
	    vec4 m2 = m * m;
	    vec4 m3 = m2 * m;
	    vec4 m4 = m2 * m2;
	    vec3 grad =
	      -6.0 * m3.x * x0 * dot(x0, g0) + m4.x * g0 +
	      -6.0 * m3.y * x1 * dot(x1, g1) + m4.y * g1 +
	      -6.0 * m3.z * x2 * dot(x2, g2) + m4.z * g2 +
	      -6.0 * m3.w * x3 * dot(x3, g3) + m4.w * g3;
	    vec4 px = vec4(dot(x0, g0), dot(x1, g1), dot(x2, g2), dot(x3, g3));
	    return 42.0 * vec4(grad, dot(m4, px));
	}


	float GetLineLightAtt(vec3 pos, vec3 lineA, vec3 lineB)
	{
		float dummyT = 0.0;
		vec3 diffuseLightPos = GetMRPDiffuse(pos, lineA, lineB, dummyT);
		float d = length(diffuseLightPos - pos);
		return pow(clamp(1.f - pow(d / 25.0, 2.0), 0.f, 1.f), 2.0);
	}

	vec3 GetLineLightShading(vec3 pos, vec3 N, vec3 R, vec3 V, vec3 albedo, vec3 lineA, vec3 lineB, float attRad, float diffScale)
	{
		vec3 light = vec3(0.0);
		{
			float dummyT = 0.0;
			vec3 diffuseLightPos = GetMRPDiffuse(pos, lineA, lineB, dummyT);
			
			vec3 l = diffuseLightPos - pos;
			float d = length(l);
			l = l / d;

			float NdotL = max(0.0, dot(N, l));
			//NdotL = MapToRange(NdotL, 0.0, 1.0, 0.25, 1.0);

			float attenuation = pow(clamp(1.f - pow(d / attRad, 2.0), 0.f, 1.f), 1.0);

			light += (albedo / PI) * attenuation * NdotL * diffScale;
		}

		{
			float dummyT = 0.0;
			vec3 specularMRP = GetMRPSpecularOptimized(pos, lineA, lineB, R, dummyT);

			vec3 l = specularMRP - pos;
			float d = length(l);
			l = l/d;

			float NdotL = max(0.0, dot(N, l));

			vec3 H = normalize(V + l);

			float NdotH = max(0.0, dot(N, H));

			float attenuation = pow(clamp(1.f - pow(d / attRad, 2.0), 0.f, 1.f), 1.0);

			// Standard unnormalized Blinn-Phong specular BRDF. Replace with whatever you like
			light += albedo * vec3(pow(NdotH, pow(1000.0, 1.0 - 0.05))) * attenuation * NdotL * 10.0;
		}
		return light;
	}

	vec2 crtCurve(vec2 uv, float r) 
	{
	    uv = (uv - 0.5) * 2.0;// uv is now -1 to 1
	    uv = r*uv/sqrt(r*r -dot(uv, uv));
	    uv = (uv / 2.0) + 0.5;// back to 0-1 coords
	    return uv;
	}

	float roundSquare(vec2 p, vec2 b, float r)
	{
	    return length(max(abs(p)-b,0.0))-r;
	}


	vec3 getTVScreenColor(vec2 uv, float camZ)
	{
		const float NO_OF_LINES = 1080.0 * 0.3;
		float scln = 0.5 - 0.5*cos(uv.y*3.14*NO_OF_LINES); // scanlines

		scln *= scln;

		float s = max(0.02, 1.1 - length(pow(2.0 * (uv - vec2(0.5)), vec2(4.0))));

		vec3 col = textureLod(ProjectorTexture, vec2(uv.x, 1.0 - uv.y), 0.f).rgb * 2.75;

		float noise = hashf(uv.x + uv.y * SceneBuffer.Time) * 2.0;

		float lerpParam = MapToRangeClamped(camZ, 140.0, 146.5, 0.0, 1.0);

		col = mix(vec3(noise), col, lerpParam);

		return s * scln * vec3(0.9, 1.0, 0.95) * col;
	}

	vec4 GetTVColor(vec2 uv, float camZ)
	{
		vec3 c = vec3(0.0);
		float r = 2.0;

		vec2 uvS = crtCurve(uv, r);

		// Screen Content
		vec2 uvC = (uvS - 0.5)* 2.0; // screen content coordinate system
		uvC *= 1.3;
		uvC = (uvC / 2.0) + 0.5;

		vec2 uvU = uvC;

		if(uvU.x < 0.0 || uvU.x > 1.0 ||  uvU.y < 0.0 || uvU.y > 1.0)
		{

		}
		else
		{
			c += getTVScreenColor(uvU, camZ);
		}

		vec2 uvE = crtCurve(uv, r+0.25);

		const float SIZE = 0.37;
		const float SMOOTH = 0.003;

		vec3 borders = vec3(0.0);

		const float innerSize = 0.005;
		const float outerSize = 0.075;

		const float rad = 0.015;
		
		float alpha = smoothstep(SMOOTH, -SMOOTH, roundSquare(uvE-vec2(0.5, 0.5), vec2(SIZE) + outerSize, rad));

		float s = 1.1 - length(pow(2.0 * (uvS - vec2(0.5)), vec2(1.0)));

		borders += s * 3.5 * 
        smoothstep(-SMOOTH, SMOOTH, roundSquare(uvS-vec2(0.5, 0.5), vec2(SIZE), rad)) * 
        smoothstep(SMOOTH, -SMOOTH, roundSquare(uvE-vec2(0.5, 0.5), vec2(SIZE) + innerSize, rad));
    
    	// Outer Border
    	borders += 0.15 * 
       	smoothstep(-SMOOTH, SMOOTH, roundSquare(uvE-vec2(0.5, 0.5), vec2(SIZE) + innerSize, rad)) * 
        alpha;

		borders = max(vec3(0.0), borders);

		return vec4(borders * 0.1 + c, alpha);
	}


	bool bPyramidIntersection(vec3 rayOrigin, vec3 rayDir, out float smallestDist, out float finalT)
	{
		bool bPyrInter = false;

		float pyrExtent = 65.0 * 0.65 - 3.0;
		vec3 pyrPos = vec3(0.0, 41.0, 200.0);
		float pyrScale = (1.0 / 65.0);

		vec4 rayPayramidIntersectionRes = RayAABBIntersection(rayOrigin, rayDir, pyrPos - vec3(0.0, pyrExtent * 0.5, 0.0), vec3(pyrExtent * 0.5 * 1.25));
		bPyrInter = rayPayramidIntersectionRes.x > 0.0;

		smallestDist = 1.0;
		
		//if(bPyrInter)
		{
			// raymarch
			const float pyrtmax = 500.0;
			float pyrt = rayPayramidIntersectionRes.y;
			for( int i=0; i<128; i++ )
			{
				vec3 pos = rayOrigin + pyrt*rayDir;
				float h = sdPyramid(pos, pyrPos, pyrScale, pyrHeight);

				smallestDist = min(h, smallestDist);

				if(h<0.001*pyrt) 
				{
					finalT = pyrt;
					return true;
				}
				if(pyrt>pyrtmax)
				{
					return false;
				}
				pyrt += h;
			}
		}
	}



	`;
}
